import { render, staticRenderFns } from "./PreviewFormsAPSP.vue?vue&type=template&id=72fed24b"
import script from "./PreviewFormsAPSP.vue?vue&type=script&lang=ts"
export * from "./PreviewFormsAPSP.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports